function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import $ from 'jquery';
export default class HeaderButton {
  constructor(header, label, cssClass, action) {
    _defineProperty(this, "element", void 0);
    _defineProperty(this, "_header", void 0);
    _defineProperty(this, "_action", void 0);
    this._header = header;
    this.element = $('<li class="' + cssClass + '" title="' + label + '"></li>');
    this._header.on('destroy', this._$destroy, this);
    this._action = action;
    this.element.on('click', this._action);
    this._header.controlsContainer.append(this.element);
  }
  _$destroy() {
    this.element.off();
    this.element.remove();
  }
}
//# sourceMappingURL=HeaderButton.js.map